import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import AudienceNote from "./audience-note";
import GuidelinesContent from "./guidelines-content";
import { DIALOG_COLORS, dialogFooterSx, dialogHeaderSx, dialogPaperSx, footerButtonSx } from "./styles";

interface GuidelinesDialogProps {
	open: boolean;
	onClose: () => void;
	isCp: boolean;
}

const GuidelinesDialog = ({ open, onClose, isCp }: GuidelinesDialogProps) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="md" sx={dialogPaperSx}>
			<DialogTitle sx={{ ...dialogHeaderSx, fontSize: 22, fontWeight: 700 }}>
				{t("site_visit_comment.guidelines.popup_title")}
				<IconButton
					aria-label={t("site_visit_comment.dialog.close")}
					onClick={onClose}
					sx={{ position: "absolute", right: 16, top: 20, color: DIALOG_COLORS.muted }}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent sx={{ px: 3.5, pb: 3 }}>
				{isCp && <AudienceNote />}
				<GuidelinesContent isCp={isCp} expanded />
			</DialogContent>
			<DialogActions sx={dialogFooterSx}>
				<Button
					onClick={onClose}
					variant="outlined"
					sx={{ ...footerButtonSx, color: DIALOG_COLORS.text, borderColor: DIALOG_COLORS.border }}
				>
					{t("site_visit_comment.dialog.close")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default GuidelinesDialog;
